import { Button } from "@component/button";
import { Checkbox } from "@component/checkbox";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@component/dialog";
import { Label } from "@component/label";
import { AlertTriangleIcon } from "lucide-react";
import { useState } from "react";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    onDontShowAgain: (dontShow: boolean) => void;
}

export default function JobRecalculatedDialog(props: Props) {
    const [dontShowAgain, setDontShowAgain] = useState<boolean>(false);

    return (
        <Dialog open={props.isOpen} onOpenChange={props.onClose}>
            <DialogContent className="sm:max-w-[560px] p-0">
                <DialogHeader className="px-6 pt-6 pb-4">
                    <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-12 h-12 rounded-full bg-yellow-100 flex items-center justify-center">
                            <AlertTriangleIcon className="h-6 w-6 text-yellow-600" />
                        </div>
                        <div className="flex-1 pt-1">
                            <DialogTitle className="text-2xl font-bold text-gray-900">
                                Match Scores Will Be Recalculated
                            </DialogTitle>
                        </div>
                    </div>
                </DialogHeader>

                <div className="px-6 pb-4">
                    <DialogDescription className="text-base text-gray-600">
                        Editing this job will update and recalculate all candidate match
                        scores.
                    </DialogDescription>
                </div>

                <div className="px-6 pb-4">
                    <div className="flex items-center space-x-2">
                        <Checkbox
                            id="dont-show-again"
                            checked={dontShowAgain}
                            onCheckedChange={(checked) => {
                                setDontShowAgain(checked as boolean)
                                props.onDontShowAgain(checked as boolean)
                            }}
                            className="data-[state=checked]:bg-blue-600 data-[state=checked]:border-blue-600"
                        />

                        <Label
                            htmlFor="dont-show-again"
                            className="text-sm text-gray-600 cursor-pointer"
                        >
                            Don't show this message again
                        </Label>
                    </div>
                </div>

                <DialogFooter className="px-6 pb-6 gap-3">
                    <Button
                        variant="outline"
                        onClick={props.onClose}
                        className="px-6 border-gray-300"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={props.onConfirm}
                        className="px-6 bg-blue-600 hover:bg-blue-700"
                    >
                        Continue Editing
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
